import FruitCard from "../../layouts/FruitCard";
import bg from "/cywe-assets/card/lime.png";
import fruit from "/cywe-assets/fruit/granny-smith-apple.png";

export default function Lime({
	setValue,
	value,
}: {
	setValue: (value: number) => void;
	value: number;
}) {
	return (
		<>
			<FruitCard
				title="God produces patience through the trials we endure!"
				description="Patience is rewarded (the best type of reward) no matter how much you endure, how hard it may be, how impossible that it may seem, you persevere. You are patient because you have strong faith in God and know He will show you the best way to go."
				bg={bg}
				fruit={fruit}
				setValue={setValue}
				value={value}
				back="/experience/3"
				next="/experience/5"
			/>
		</>
	);
}
